import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoginSms, SelectMethod } from "../actions/login";
import { SmsForm } from '../models/login.model';

import * as fromLogin from '../reducers';

@Component({
  selector: 'spaq-login-sms-page',
  template: `
    <h1>Connexion</h1>
    <spaq-login-nav (onSelect)="onSelectMethod($event)" selected="sms"></spaq-login-nav>
    <spaq-login-sms (onSubmit)="onSubmit($event)"
                    [formData]="form$ | async"
                    [pending]="pending$ | async"
                    [error]="error$ | async"
                    [captchaSolved]="captchaSolved$ | async"
                    [codeConfirmed]="codeConfirmed$ | async"></spaq-login-sms>
  `,
  styles: [],
})
export class LoginSmsPageComponent implements OnInit {
  captchaSolved$ = this.store.select(fromLogin.getLoginSmsPageCaptchaSolved);
  codeConfirmed$ = this.store.select(fromLogin.getLoginSmsPageCodeConfirmed);
  error$ = this.store.select(fromLogin.getLoginSmsPageError);
  form$ = this.store.select(fromLogin.getLoginSmsPageForm);
  pending$ = this.store.select(fromLogin.getLoginSmsPagePending);
  step = 1;

  constructor(private store: Store<any>) {
  }

  ngOnInit() {
  }

  onSelectMethod($event) {
    this.store.dispatch(new SelectMethod($event));
  }
  onSubmit($event: SmsForm) {
    console.log($event);
    this.store.dispatch(new LoginSms($event));
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/containers/login-sms-page.component.ts